<template>
    <div class="page">
        <Header title="集卡排行榜" />
        <div class="rank-box">
            <div class="rank-bg">
                <div class="rank_1 rank" >
                    <template v-if="rankTop3List[0]">
                        <div class="rank-top-name van-ellipsis">{{rankTop3List[0].clientName}}</div>
                        <div class="rank-top-count van-ellipsis">已集齐<span class="color-orange">{{rankTop3List[0].prizeCount || 0}}</span>次BOSCH</div>
                    </template>
                    <div class="rank-top-name" v-else>未上榜</div>
                    </div>
                    <div class="rank_2 rank">
                    <template v-if="rankTop3List[1]">
                    <div class="rank-top-name van-ellipsis">{{rankTop3List[1].clientName}}</div>
                    <div class="rank-top-count van-ellipsis">已集齐<span class="color-orange">{{rankTop3List[1].prizeCount || 0}}</span>次BOSCH</div>
                    </template>
                    <div class="rank-top-name" v-else>未上榜</div>
                    </div>
                    <div class="rank_3 rank" >
                    <template v-if="rankTop3List[2]">
                    <div class="rank-top-name van-ellipsis">{{rankTop3List[2].clientName}}</div>
                    <div class="rank-top-count van-ellipsis">已集齐<span class="color-orange">{{rankTop3List[2].prizeCount || 0}}</span>次BOSCH</div>
                    </template>
                    <div class="rank-top-name" v-else>未上榜</div>
                    </div>
            </div>
        </div>
        <div class="rank-get">
            <div class="rank-text">集齐BOSCH次数最多的<span class="color-orange">前3名</span>可获得88888积分！</div>
        </div>
        <div class="rank-box">
            <div class="rank-list">
                <div class="rank-mine">
                    <van-row>
                        <van-col span="5" class="color-orange">我</van-col>
                        <van-col span="6" class="van-ellipsis">{{ clientInfo.clientName }}</van-col>
                        <van-col span="5" class="color-orange">
                            <span v-if="clientRankingList.ranking">第{{ clientRankingList.ranking }}名</span>
                            <span v-else>未上榜</span>
                        </van-col>
                        <van-col span="8" style="font-size:10px;line-height: 16px;" class="text-right">
                            已集齐<span class="color-orange">{{ clientRankingList.prizeCount || 0 }}</span>次BOSCH
                        </van-col>
                    </van-row>
                </div>
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="van-list">
                    <div class="rank-tops">
                        <van-row gutter="5" class="rank-list-item">
                            <van-col span="5">排名</van-col>
                            <van-col span="10" class="van-ellipsis">名称</van-col>
                            <van-col span="9" class="text-right">集齐BOSCH总次数</van-col>
                        </van-row>
                        <van-row gutter="5" v-for="item in rankingList" :key="item.clientId" class="rank-list-item">
                            <van-col span="5">{{ item.ranking }}</van-col>
                            <van-col span="11" class="van-ellipsis">{{ item.clientName }}</van-col>
                            <van-col span="8" class="van-ellipsis">已集齐<span class="color-orange">{{
                                item.prizeCount }}</span>次BOSCH</van-col>
                        </van-row>
                    </div>
                </van-list>

            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
export default {
  components: {
    Header
  },
  data () {
    return {
      clientInfo: {},
      pageInfo: {
        page: 1,
        pageSize: 10
      },
      clientRankingList: {
        'alreadySign': false,
        'clientId': '',
        'createDate': 0,
        'prizeCount': '',
        'ranking': ''
      },
      loading: false,
      finished: false,
      rankingList: [],
      rankTop3List: ['', '', '']
    }
  },
  computed: {},
  created () {
    this.clientInfo = userUtils.getClientInfo() || ''
  },
  methods: {
    onLoad () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      let dataParams = {
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize
      }
      activityApi.getCardRankList(dataParams).then(res => {
        if (res.data.resultCode === '0') {
          const { rankingList, clientRankingList, pageInfo } = res.data.resultData
          this.clientRankingList = clientRankingList || {}
          this.rankingList = this.rankingList.concat(rankingList || [])
          for (let i = 0; i < this.rankingList.length; i++) {
            if (this.rankingList[i].ranking === '1') {
              this.rankTop3List[0] = this.rankingList[i]
            }
            if (this.rankingList[i].ranking === '2') {
              this.rankTop3List[1] = this.rankingList[i]
            }
            if (this.rankingList[i].ranking === '3') {
              this.rankTop3List[2] = this.rankingList[i]
            }
          }
          this.loading = false
          this.pageInfo.page++
          if (this.pageInfo.page > pageInfo.totalPages) {
            this.finished = true
          }
        }
        this.$toast.clear()
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>
<style lang='less' scoped>
.page {
    background-color: #246771;
    width: 100%;
    height: 100%;
}

.rank-box {
    padding: 16px;
    background-color: #246771;

    .rank-bg {
        width: 100%;
        height: 180px;
        background: url('../../../assets/images/activity/collect-cards/group_rank.png') no-repeat;
        background-size: 100% auto;
        // padding: 5px;
        box-sizing: border-box;
        position: relative;

        .rank_2 {
            position: absolute;
            top: 50%;
            left: 0%;
        }

        .rank_1 {
            position: absolute;
            top: 40%;
            left: 35%;
        }

        .rank_3 {
            position: absolute;
            top: 50%;
            left: 70%;
        }

        .rank {
            display: inline-block;
            text-align: center;
            width: 100px;
            height: 142px;
            color: #fff;

            .rank-top-name {
                font-size: 14px;
                line-height: 20px;
            }

            .rank-top-count {
                font-size: 10px;
            }

        }
    }

    .rank-list {
        background-color: #4E8C96;
        min-height: 500px;
        width: 100%;
        border: 1px solid #fff;
        border-radius: 10px;
        padding: 15px;
        box-sizing: border-box;
        color: #fff;

        .rank-mine {
            background-color: #246771;
            width: 100%;
            padding: 27px 12px;
            border-radius: 10px;
            box-sizing: border-box;
        }

        .rank-tops {
            font-size: 12px;
            padding: 0px 5px;
        }

        .rank-list-item {
            padding: 20px 0px;
        }
    }

}

.rank-get {
    width: 100%;
    height: 30px;
    background: url('../../../assets/images/activity/collect-cards/rank_get.png') no-repeat;
    background-size: 100% auto;
    box-sizing: border-box;

    .rank-text {
        padding-left: 35px;
        font-size: 12px;
        line-height: 30px;
        color: #fff;
    }
}

.color-orange {
    color: #F1990A;
}</style>
